import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import SideBar from './components/SideBar';
const DashboardLayout = () => {
    return (_jsxs("div", { className: "h-screen w-screen", children: [_jsx(SideBar, {}), _jsx(Header, {}), _jsx("main", { id: "main", children: _jsx("div", { children: _jsx(Outlet, {}) }) })] }));
};
export default DashboardLayout;
